"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRangeBoundingClientRect = void 0;
var _plateCommon = require("@udecode/plate-common");
var _createVirtualElement = require("../createVirtualElement");
/** Get bounding client rect by slate range */
var getRangeBoundingClientRect = function getRangeBoundingClientRect(editor, at) {
  if (!at) return (0, _createVirtualElement.getDefaultBoundingClientRect)();
  var domRange = (0, _plateCommon.toDOMRange)(editor, at);
  if (!domRange) return (0, _createVirtualElement.getDefaultBoundingClientRect)();
  return domRange.getBoundingClientRect();
};
exports.getRangeBoundingClientRect = getRangeBoundingClientRect;